import { Phone, MessageCircle, ArrowUpRight, Sparkles, Calendar, Award, MapPin, ShieldCheck, Users } from "lucide-react";
const NAVY = "#081438";
const NAVY_LIGHT = "#243752";
const NAVY_DEEP = "#040A1F";
const GOLD = "#F5A623";
const FONT_HEAD = "'Plus Jakarta Sans', system-ui, sans-serif";
const FONT_BODY = "'Manrope', system-ui, sans-serif";
const TRUST_PILLARS = [{
  num: "Since '09",
  label: "Family-run, Bass Hill NSW",
  icon: Users
}, {
  num: "5.0★",
  label: "Google rated installations",
  icon: Award
}, {
  num: "150+",
  label: "Sydney suburbs serviced",
  icon: MapPin
}, {
  num: "12 mo",
  label: "Workmanship warranty in writing",
  icon: ShieldCheck
}, {
  num: "2–4 wk",
  label: "Measure to install day",
  icon: Calendar
}];
export default function InstallationFinalCta() {
  return <section className="relative overflow-hidden" style={{
    backgroundColor: NAVY,
    fontFamily: FONT_BODY
  }} aria-labelledby="installation-final-cta-heading">
      {/* Background atmospherics */}
      <div aria-hidden className="absolute inset-0 pointer-events-none" style={{
      background: `radial-gradient(ellipse at 50% 0%, ${NAVY_LIGHT}99 0%, transparent 60%), radial-gradient(ellipse at 10% 100%, ${GOLD}14 0%, transparent 50%), radial-gradient(ellipse at 90% 80%, ${NAVY_DEEP} 0%, transparent 60%)`
    }} />

      <div aria-hidden className="absolute inset-0 opacity-[0.05] mix-blend-overlay pointer-events-none" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.9 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")"
    }} />

      {/* Top gold scanline */}
      <div aria-hidden className="absolute top-0 left-0 right-0 h-px" style={{
      background: `linear-gradient(90deg, transparent 0%, ${GOLD}80 50%, transparent 100%)`
    }} />

      {/* Watermark text */}
      <div aria-hidden className="absolute inset-x-0 top-1/2 -translate-y-1/2 flex items-center justify-center pointer-events-none select-none overflow-hidden">
        <span className="font-extrabold whitespace-nowrap" style={{
        fontFamily: FONT_HEAD,
        color: `${GOLD}08`,
        fontSize: "clamp(8rem, 22vw, 22rem)",
        letterSpacing: "-0.05em",
        lineHeight: 0.9
      }}>
          INSTALL
        </span>
      </div>

      <div className="relative mx-auto max-w-7xl px-6 lg:px-10 pt-24 md:pt-32 pb-20 md:pb-24">

        {/* Top eyebrow with ornament */}
        <div className="flex items-center justify-center gap-4 mb-10">
          <span aria-hidden className="h-px w-16" style={{
          backgroundColor: `${GOLD}66`
        }} />
          <div className="flex items-center gap-2.5">
            <Sparkles className="h-3.5 w-3.5" strokeWidth={2.5} style={{
            color: GOLD
          } as React.CSSProperties} />
            <span className="text-[11px] font-bold tracking-[0.32em] uppercase" style={{
            color: GOLD
          }}>
              New Door · New Feel · One Family
            </span>
            <Sparkles className="h-3.5 w-3.5" strokeWidth={2.5} style={{
            color: GOLD
          } as React.CSSProperties} />
          </div>
          <span aria-hidden className="h-px w-16" style={{
          backgroundColor: `${GOLD}66`
        }} />
        </div>

        {/* The big emotional headline */}
        <div className="text-center mb-12 md:mb-14">
          <h2 id="installation-final-cta-heading" className="font-extrabold text-white" style={{
          fontFamily: FONT_HEAD,
          fontSize: "clamp(2.5rem, 7vw, 6rem)",
          lineHeight: 0.98,
          letterSpacing: "-0.035em"
        }}>
            This time{" "}
            <span style={{
            color: GOLD
          }}>next month</span>
            <span className="block mt-2 md:mt-3">a new front to your home.</span>
          </h2>

          <p className="mt-8 mx-auto text-base md:text-lg leading-relaxed max-w-2xl" style={{
          fontFamily: FONT_BODY,
          color: "rgba(255,255,255,0.78)"
        }}>
            Free on-site measure. Fixed-price quote.{" "}
            <span className="text-white font-semibold">One-day install.</span>{" "}
            The most-used moving part of your house &mdash; built right,
            installed right, warranted right.
          </p>
        </div>

        {/* CTA row */}
        <div className="flex items-center justify-center gap-3 flex-wrap mb-12 md:mb-14">
          <a href="tel:0485000933" className="group inline-flex items-center justify-center gap-3 rounded-full px-8 py-[18px] text-[15px] md:text-[16px] font-bold transition-all duration-200 hover:scale-[1.03] active:scale-[0.98]" style={{
          backgroundColor: GOLD,
          color: NAVY,
          fontFamily: FONT_BODY,
          boxShadow: `0 18px 48px -10px ${GOLD}99`
        }}>
            <Phone className="h-5 w-5" strokeWidth={2.5} />
            <span>Book My Free Measure &mdash; 0485 000 933</span>
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={2.5} />
          </a>

          <a href="https://wa.me/61485000933" className="group inline-flex items-center justify-center gap-2 rounded-full border-2 px-7 py-[15px] text-[14px] font-bold text-white transition-all duration-200" style={{
          borderColor: "rgba(255,255,255,0.30)",
          fontFamily: FONT_BODY
        }} onMouseEnter={e => {
          e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.08)";
          e.currentTarget.style.borderColor = "rgba(255,255,255,0.55)";
        }} onMouseLeave={e => {
          e.currentTarget.style.backgroundColor = "transparent";
          e.currentTarget.style.borderColor = "rgba(255,255,255,0.30)";
        }}>
            <MessageCircle className="h-[18px] w-[18px]" strokeWidth={2.5} />
            WhatsApp Us
          </a>
        </div>

        {/* Trust pillars row */}
        <div className="relative rounded-2xl border backdrop-blur-sm overflow-hidden" style={{
        backgroundColor: "rgba(255,255,255,0.025)",
        borderColor: "rgba(255,255,255,0.10)"
      }}>
          <div aria-hidden className="absolute top-0 left-8 right-8 h-px" style={{
          background: `linear-gradient(90deg, transparent 0%, ${GOLD}66 50%, transparent 100%)`
        }} />

          <ul className="grid grid-cols-2 md:grid-cols-5 divide-x divide-y md:divide-y-0" style={{
          borderColor: "rgba(255,255,255,0.08)"
        }}>
            {TRUST_PILLARS.map((pillar, idx) => {
            const Icon = pillar.icon;
            return <li key={pillar.label} className="flex flex-col items-center justify-center text-center px-4 py-6 md:py-7" style={{
              borderColor: "rgba(255,255,255,0.08)",
              borderLeft: idx === 0 ? "none" : undefined
            }}>
                  <Icon className="h-4 w-4 mb-3 opacity-70" strokeWidth={2} style={{
                color: GOLD
              } as React.CSSProperties} />
                  <div className="font-extrabold mb-1" style={{
                fontFamily: FONT_HEAD,
                color: "white",
                fontSize: "clamp(1.0625rem, 1.6vw, 1.25rem)",
                lineHeight: 1,
                letterSpacing: "-0.02em",
                fontVariantNumeric: "tabular-nums"
              }}>
                    {pillar.num}
                  </div>
                  <div className="text-[10.5px] font-semibold tracking-[0.10em] uppercase leading-snug" style={{
                color: "rgba(255,255,255,0.55)",
                fontFamily: FONT_BODY
              }}>
                    {pillar.label}
                  </div>
                </li>;
          })}
          </ul>
        </div>

        {/* Bottom monogram signature */}
        <div className="mt-16 md:mt-20 flex flex-col items-center gap-3">
          <div className="flex items-center justify-center w-12 h-12 rounded-full font-extrabold text-sm border" style={{
          backgroundColor: "rgba(245,166,35,0.10)",
          color: GOLD,
          borderColor: `${GOLD}66`,
          fontFamily: FONT_HEAD,
          letterSpacing: "-0.02em"
        }}>
            GG
          </div>
          <p className="text-[11px] font-bold tracking-[0.28em] uppercase text-center" style={{
          color: "rgba(255,255,255,0.45)"
        }}>
            Gold Garage Door &mdash; Family-Run Since 2009
          </p>
        </div>
      </div>

      {/* Bottom gold scanline */}
      <div aria-hidden className="absolute bottom-0 left-0 right-0 h-px" style={{
      background: `linear-gradient(90deg, transparent 0%, ${GOLD}80 50%, transparent 100%)`
    }} />
    </section>;
}